export default ({
  backgroundColor: '#f6f9fb',
  headerBackgroundColor: '#e3e8ee',
  headerColor: '#61686f',
  headerColorActive: '#222',
  headerFocusColor: 'rgba(0, 0, 0, 0.05)',
  sidebarBackgroundColor: '#fff',
  sidebarColor: '#61686f',
  sidebarColorActive: '#222',
  sidebarDarkMode: false,
  sidebarHeaderBackgroundColor: '#e3e8ee',
  sidebarHeaderBorderColor: '#e3e8ee',
  sidebarHeaderColor: '#61686f',
  sidebarHeaderColorActive: '#222',
  sidebarInnerBackgroundColor: '#f1f5f8',
  sidebarInnerColor: '#61686f',
  sidebarInnerColorActive: '#222'
});
